import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SparePartRequestLineDetails,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.sparePart}requestLine/${COMMON_QUERY_PARAMS.REQUEST_LINE_ID}`;

export interface GetSparePartRequestLineDetailsRequestArgs {
  sparePartRequestLineId: string;
}

export const getSparePartRequestLineDetailsRequest = ({
  sparePartRequestLineId,
}: GetSparePartRequestLineDetailsRequestArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(
    COMMON_QUERY_PARAMS.REQUEST_LINE_ID,
    sparePartRequestLineId,
  ),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getSparePartRequestLineDetailsQuery = async (
  payload: GetSparePartRequestLineDetailsRequestArgs,
): Promise<BackResponse<SparePartRequestLineDetails> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<SparePartRequestLineDetails>>(
      getSparePartRequestLineDetailsRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
